import React from 'react';
import { connect } from 'react-redux';
import { setImages } from '../actions/reviewActions';
import { Button } from 'reactstrap';
import { Form, Input, InputGroup } from 'reactstrap';

const ReviewStep2 = ({ reviews, setImages, previousStep, nextStep }: any) => {
  const handleUploadPhotoClick = () => {
    document.getElementById('reviewImage').click();
  };

  const onImageSelect = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    let data: any = {};
    reader.onloadend = () => {
      data.image = file;
      data.url = reader.result as string;
      setImages(data);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="text-center  parent">
      <div className="px-5  py-3">
        <h4 className="font-weight-bold my-3 ">SHOW IT OFF</h4>
        <h4 className="font-weight-bold my-3 text-muted ">WE'D LOVE TO SEE IT IN ACTION!</h4>

        <div className="my-3 ">
          <Form encType="multipart/form-data" onSubmit={(e) => e.preventDefault()}>
            <InputGroup className="mx-auto">
              <Input
                id="reviewImage"
                accept="image/png, image/jpeg"
                type="file"
                style={{ display: 'none' }}
                onChange={onImageSelect}
              />
            </InputGroup>
          </Form>
        </div>

        <div>
          {reviews.imageUrl !== '' && (
            <img className="my-3" style={{ height: 200 }} src={reviews.imageUrl} alt="new review" />
          )}
        </div>
        <Button outline color="dark" onClick={handleUploadPhotoClick}>
          Upload a photo
        </Button>
      </div>

      <div style={{ bottom: 0 }}>
        <div className="float-left">
          <Button outline color="dark" className="border-0" onClick={() => previousStep()}>
            {' '}
            Back{' '}
          </Button>
        </div>
        <div className="float-right">
          <Button outline color="dark" className="border-0" onClick={() => nextStep()}>
            {' '}
            {reviews.imageUrl !== '' ? 'Next' : 'Skip'}{' '}
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  reviews: state.reviews,
});

export default connect(mapStateToProps, { setImages })(ReviewStep2);
